import type { GetBookingsQueryParams } from '../../types/booking.js'

export const bookingKeys = {
  all: ['bookings'] as const,
  byEstimateResponse: (estimateResponseId: string) =>
    ['booking', 'estimate-response', estimateResponseId] as const,
  detail: (id: string) => ['booking', 'detail', id] as const,
  history: (id: string) => ['booking', 'history', id] as const,
  // Sous la clé du détail : les mutations qui invalident `detail` (ajout, annulation d'un
  // voyage, prix d'un voyageur) rafraîchissent aussi l'aperçu des lignes IGA.
  igaServices: (id: string) => ['booking', 'detail', id, 'iga-services'] as const,
  list: (params: GetBookingsQueryParams) => ['bookings', 'list', params] as const,
  myBookingByRef: (ref: string) => ['me', 'bookings', ref] as const,
  myBookings: ['me', 'bookings'] as const,
  origin: (estimateResponseId: string) => ['booking', 'origin', estimateResponseId] as const,
}
